import React from 'react'
import Image from 'next/image'
import fire from './fire.png'
import Marquee from 'react-fast-marquee'

export const RelatedPProducts = () => {
    return (
        <div className='flex flex-col gap-10 pb-20'>
            <h1 className='text-title-4 font-bold px-5 xl:px-15'>Related Product and services</h1>
            <Marquee speed={50} gradient={false} pauseOnHover={true} >
                {
                    RelatedProductsData.map((e) =>
                        <RelatedProductsCards imageUrl={e.imageUrl} label={e.label} description={e.description} />
                    )
                }

            </Marquee>
        </div>
    )
}

const RelatedProductsData = [
    {
        imageUrl: fire,
        label: 'Bharat Griha Raksha ',
        description: 'Bharat Griha Raksha is a specialized home insurance product designed to protect Indian homes and their contents against various risks and perils. It offers comprehensive coverage and financial support to homeowners, ensuring peace of mind and security for their most valuable asset.'
    },
    {
        imageUrl: fire,
        label: 'Bharat Laghu Udyam Suraksha ',
        description: 'Bharat Laghu Udyam Suraksha is a specialized insurance product tailored to meet the needs of small enterprises in India. It provides comprehensive coverage and financial support to small businesses, ensuring their resilience against various risks and uncertainties.'
    },
    {
        imageUrl: fire,
        label: 'Bharat Sookshma Udyam ',
        description: 'Bharat Sookshma Udyam Suraksha is a specialized insurance product aimed at providing comprehensive coverage and financial support to micro-enterprises in India. It is specifically tailored to address the unique needs and challenges faced by small-scale businesses, ensuring their resilience against various risks and uncertainties'
    },
    {
        imageUrl: fire,
        label: 'Product Liability ',
        description: 'Product liability insurance covers the class of insurance for tangible goods or products, which manufacturers, marketers, distributor, wholesaler, retailer and traders become liable to pay legal expenses against third party bodily injury/property damage liability arising out of the use or consumption of product manufactured, sold, handled, distributed or disposed of by you. '
    },
    {
        imageUrl: fire,
        label: 'Public Liability Insurance',
        description: 'Public liability insurance protects you and your business against the financial risk of being found liable to a third party for death or injury, loss or damage to property or economic loss resulting from your negligence. '
    },
    {
        imageUrl: fire,
        label: 'Standard Fire And Special Perils',
        description: 'This insurance policy covers various perils such as fire, lightning, explosion/implosion, impact damage, aircraft impact. bursting/overflowing of water tanks/pipes/apparatus, sprinkler leakage, subsidence, landslide, rockslide, riots, strikes, malicious damage, missile testing operations. Additionally, there are add on options to cover Earthquake. '
    },
]

export const RelatedProductsCards = ({
    imageUrl, label, description
}: {
    imageUrl: any;
    label: string;
    description: string;
}) => {
    return (
        <div className='border border-grey-200 rounded-lg mr-10 h-full'>
            <div className='p-6 flex flex-col gap-6'>
                <div className='bg-surface-red p-[10px] w-12 rounded-xl'>
                    <Image src={fire} alt={''} width={26} height={26} />
                </div>
                <div className='flex flex-col gap-2'>

                    <h1 className='text-title-6 font-bold'>{label}</h1>
                    <p className='text-body-1 font-normal max-w-[300px]'> {description}</p>
                </div>
            </div>
        </div>
    )
}

export const SuretyBondFaqList = [
    {
        question: 'What is Surety Bond? ',
        answer:
            "Surety Bond is a risk transfer mechanism wherein an Insurer/ Surety provides a guarantee to a Beneficiary that the Contractor will meet his contractual obligations. In case the Contractor fails to deliver his promise, a monetary compensation is paid to the Beneficiary by the Insurer. ",
    },
    {
        question: 'What are the major exclusions in Surety Bond? ',
        answer:
            `<li> Contract termination between Contractor & beneficiary prior to insurance </li>
    <li>Changing terms of contract without the knowledge of the Surety insurer </li>
    <li>Gross Negligence, illegal /criminal acts by both Contractor & beneficiary </li>
    <li>War/Act of God/Force-majeure/Nuclear Perils </li>
    <li>Fraud/Collusion  </li>
    <li>Any third-party loss not part of the contract   </li>
    <li>Any price fluctuation in execution of the project </li>
    `,
    },
    {
        question: 'Who can buy Surety Bond ? ',
        answer: "A contractor who has been awarded with a contract to execute a project / supply machinery and required to provide security to the Beneficiary / project owners at bidding and performance stages of contract, can obtain this policy. ",
    },
    {
        question: 'How is bank guarantee different from Shorty bonds ',
        answer: "Bank guarantees require collateral and cover repayment failures, issued by banks with payments through them. Surety bonds, needing no collateral, protect against broken contracts, issued by banks, governments, or companies, with direct transactions unless there’s a default ",
    },
    {
        question: 'what is the fees of a surety bond?  ',
        answer: "The quoted premium for surety bonds primarily depends on the principal's credit score. However, it also considers several factors such as the rating, tender type, bond type, and duration. While insurers require documentation and additional information, these elements play a crucial role in determining the final premium rate. ",
    },
];